import React, { useState } from 'react'
import AITool from '../components/AITool'
import './AssistantTools.css'

const AssistantTools: React.FC = () => {
  const [activeTool, setActiveTool] = useState('chatbot')

  const tools = [
    {
      id: 'chatbot',
      name: 'General Chatbot',
      description: 'Have a conversation with AI about any topic',
      icon: '💬',
      endpoint: '/.netlify/functions/chatbot',
      fields: [
        { name: 'message', label: 'Your Message', type: 'textarea' as const, placeholder: 'Ask me anything!' },
        { name: 'context', label: 'Context (Optional)', type: 'text' as const, placeholder: 'e.g., I\'m a student, I\'m a developer' }
      ]
    },
    {
      id: 'advisor',
      name: 'Product Advisor',
      description: 'Get personalized product recommendations based on your needs',
      icon: '🛒',
      endpoint: '/.netlify/functions/product-advisor',
      fields: [
        { name: 'category', label: 'Product Category', type: 'select' as const, options: ['Electronics', 'Books', 'Clothing', 'Home & Garden', 'Sports', 'Beauty', 'Automotive', 'Other'] },
        { name: 'budget', label: 'Budget Range', type: 'select' as const, options: ['Under $50', '$50-$100', '$100-$250', '$250-$500', '$500+'] },
        { name: 'needs', label: 'Your Needs/Requirements', type: 'textarea' as const, placeholder: 'Describe what you\'re looking for and your specific requirements' },
        { name: 'preferences', label: 'Preferences (Optional)', type: 'text' as const, placeholder: 'e.g., brand preferences, specific features' }
      ]
    },
    {
      id: 'faq',
      name: 'FAQ Assistant',
      description: 'Get answers to frequently asked questions about your business or service',
      icon: '❓',
      endpoint: '/.netlify/functions/faq-assistant',
      fields: [
        { name: 'question', label: 'Your Question', type: 'textarea' as const, placeholder: 'Ask your question here' },
        { name: 'business', label: 'Business/Service Type', type: 'select' as const, options: ['E-commerce', 'SaaS', 'Restaurant', 'Healthcare', 'Education', 'Real Estate', 'Consulting', 'Other'] },
        { name: 'context', label: 'Additional Context', type: 'textarea' as const, placeholder: 'Provide any relevant information about your business or service' }
      ]
    }
  ]

  return (
    <div className="assistant-tools">
      <div className="page-header">
        <h1>Assistant Tools</h1>
        <p>Chat with AI, get product recommendations, and find answers to your questions</p>
      </div>

      <div className="tools-tabs">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`tab-button ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
          >
            <span className="tool-icon">{tool.icon}</span>
            <span className="tool-name">{tool.name}</span>
          </button>
        ))}
      </div>

      <div className="tool-content">
        {tools.map((tool) => (
          <div key={tool.id} className={`tool-panel ${activeTool === tool.id ? 'active' : ''}`}>
            <AITool
              title={tool.name}
              description={tool.description}
              endpoint={tool.endpoint}
              fields={tool.fields}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default AssistantTools 